export const lightTheme = {
  body: '#cfe8e7',
  text: '#fefefe',
  buttonBorder: '#89C5CC',
  buttonBackground: '#415164',
  textColor: '#333333',
  bg1: '#D2F2F5',
  bg2: '#EEFAFA',
  bg3: '#D2F2F5',
  bg4: '#DDE3E9',
};
export const darkTheme = {
  body: '#415164',
  text: '#FAFAFA',
  buttonBorder: '#ffc93c',
  buttonBackground: '#9ed0c9',
  textColor: '#FAFAFA',
  bg1: '#115173',
  bg2: '#022c43',
  bg3: '#415164',
  bg4: '#053f5e',
};
